const getters = {
  processing: (state) => state.processing,
  taxes: (state) => state.taxes,
  showTaxes: (state) => state.showTaxes,
  importResult: (state) => state.importResult,
  page: (state) => state.page,
  pageSize: (state) => state.pageSize,
  totalItems: (state) => state.totalItems,
  totalPages: (state) => state.totalPages,
};
export default getters;
